import { fitGridContentToViewport } from './gridViewState';

const VIEWPORT_FIELDS = [
  'width',
  'height',
  'scrollLeft',
  'scrollTop',
  'contentWidth',
  'contentHeight',
];

export const createGridViewportStore = () => {
  let viewport = null;
  const listeners = new Set();

  return {
    getSnapshot: () => viewport,
    subscribe: (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    set: (nextViewport) => {
      if (VIEWPORT_FIELDS.every((field) => viewport?.[field] === nextViewport?.[field])) return;
      viewport = nextViewport ? { ...nextViewport } : null;
      listeners.forEach((listener) => listener());
    },
  };
};

export const getGridViewportMetrics = ({
  width,
  height,
  aspectRatio,
  zoom = 1,
  centerX = 0.5,
  centerY = 0.5,
  fitMode = 'contain',
}) => {
  const viewportWidth = Number(width) || 0;
  const viewportHeight = Number(height) || 0;
  if (!viewportWidth || !viewportHeight) return null;

  const content = fitGridContentToViewport(viewportWidth, viewportHeight, aspectRatio, fitMode);
  const boundedZoom = Math.max(1, Number(zoom) || 1);
  const contentWidth = content.width * boundedZoom;
  const contentHeight = content.height * boundedZoom;
  return {
    width: viewportWidth,
    height: viewportHeight,
    scrollLeft: Math.max(0, centerX * contentWidth - viewportWidth / 2),
    scrollTop: Math.max(0, centerY * contentHeight - viewportHeight / 2),
    contentWidth,
    contentHeight,
  };
};

export const getGridViewportPreviewStyle = (viewport) => {
  const contentWidth = Number(viewport?.contentWidth) || Number(viewport?.width) || 0;
  const contentHeight = Number(viewport?.contentHeight) || 0;
  const viewportWidth = Number(viewport?.width) || contentWidth;
  const viewportHeight = Number(viewport?.height) || 0;
  if (!contentWidth || !contentHeight || !viewportWidth || !viewportHeight) return null;

  const widthPct = Math.min(100, (viewportWidth / contentWidth) * 100);
  const heightPct = Math.min(100, (viewportHeight / contentHeight) * 100);
  const maxLeft = Math.max(0, contentWidth - viewportWidth);
  const maxTop = Math.max(0, contentHeight - viewportHeight);
  const scrollLeft = Number(viewport.scrollLeft) || 0;
  const scrollTop = Number(viewport.scrollTop) || 0;

  return {
    left: `${maxLeft ? (scrollLeft / maxLeft) * (100 - widthPct) : (100 - widthPct) / 2}%`,
    top: `${maxTop ? (scrollTop / maxTop) * (100 - heightPct) : (100 - heightPct) / 2}%`,
    width: `${widthPct}%`,
    height: `${heightPct}%`,
    widthPct,
    heightPct,
    maxLeft,
    maxTop,
  };
};